































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { QuestionFileModel } from "survey-core";
@Component
export class FileItem extends Vue {
  @Prop() question: QuestionFileModel;
  @Prop() item: any;
}
Vue.component("sv-file-item", FileItem);
export default FileItem;
